
// 团队 开票记录
export const teamInvoiceRecord = [
  { label: '合同编号', value: 'contractCode' },
  { label: '开票编号', value: 'invoiceNumber' },
  { label: '公司名称', value: 'cusName' },
  { label: '发票金额', value: 'amount' },
  { label: '发票类型', value: 'invoiceType' },
  { label: '申请人', value: 'createUser' },
  { label: '所属部门', value: 'orgName' },
  { label: '申请时间', value: 'createDate' },
  { label: '开票状态', value: 'state' },
  { label: '开票时间', value: 'invoiceDate' },
  { label: '处理人', value: 'receivePeople' }
]
// 团队 发货记录
export const teamShipmentsRecord = [
  { label: '发货编号', value: 'deliverNumber' },
  { label: '出库单编号', value: 'outstockNumber' },
  { label: '合同编号', value: 'contractCode' },
  { label: '客户名称', value: 'cusName' },
  { label: '发货方式', value: 'deliverMode' },
  { label: '请求发货时间', value: 'createDate' },
  { label: '实际发货时间', value: 'outDate' },
  { label: '发货状态', value: 'deliverState' },
  { label: '负责人', value: 'createUser' },
  { label: '所属部门', value: 'orgName' }
]

// 团队 备货记录
export const teamStockRecord = [
  { label: '备货编号', value: 'stockupCode' },
  { label: '合同编号', value: 'contractCode' },
  { label: '客户名称', value: 'cusName' },
  { label: '备货方式', value: 'stockupType' },
  { label: '请求备货时间', value: 'createDate' },
  { label: '预计发货时间', value: 'deliveryTime' },
  { label: '备货状态', value: 'stockupState' },
  { label: '负责人', value: 'createUser' },
  { label: '所属部门', value: 'orgName' }
]

// 团队 合同记录
export const teamContractRecord = [
  { label: '合同编号', value: 'contractCode' },
  { label: '客户名称', value: 'cusName' },
  { label: '客户合同编号', value: 'customerContractCode' },
  { label: '付款类型', value: 'payType' },
  { label: '合同金额', value: 'contractTotal' },
  { label: '当前负责人', value: 'staffCnName' },
  { label: '合同状态', value: 'signState' },
  { label: '所属部门', value: 'orgName' },
  { label: '签订时间', value: 'signDate' },
  { label: '型号', value: 'proType' },
  { label: '订货号', value: 'orderNumber' }
]

// 团队 提现记录
export const teamFinancePayCondition = [
  { label: '付款编号', value: 'payNumber' },
  { label: '客户名称', value: 'cusName' },
  { label: '提现金额', value: 'amount' },
  { label: '提现状态', value: 'state' },
  { label: '发起人', value: 'createUser' },
  { label: '所属部门', value: 'orgName' },
  { label: '发起时间', value: 'createDate' },
  { label: '处理人', value: 'processUser' },
  { label: '处理时间', value: 'processDate' }
]

// 团队 业绩管理
export const teamPerformanceManage = [
  { label: '销售员', value: 'staffCnName' },
  { label: '所属部门', value: 'orgName' }
]

// 团队 特价审批记录
export const teamSpecialOfferApproveRecord = [
  { label: '客户名称', value: 'cusName' },
  { label: '发起人', value: 'createUser' },
  { label: '归属部门', value: 'orgName' },
  { label: '发起时间', value: 'createDate' },
  // { label: '处理人', value: 'processUser' },
  // { label: '处理时间', value: 'processDate' },
  { label: '审批状态', value: 'state' }
]

// 团队 报价记录
export const teamQuotationRecord = [
  { label: '报价单编号', value: 'orderCode' },
  { label: '客户名称', value: 'cusName' },
  { label: '产品名称', value: 'proName' },
  { label: '型号', value: 'proType' },
  { label: '订货号', value: 'orderNumber' },
  { label: '报价总额', value: 'orderTotal' },
  { label: '供货成本', value: 'orderCost' },
  { label: '毛利率', value: 'orderRate' },
  // { label: '询价时间', value: 'miDate' },
  // { label: '反馈人', value: 'oiName' },
  // { label: '供货价反馈时间', value: 'maxDate' },
  // { label: '供货价有效期', value: 'unitDate' },
  { label: '报价单生成时间', value: 'generateDate' },
  { label: '生成合同', value: 'isContract' },
  { label: '制单人', value: 'obName' },
  { label: '所属部门', value: 'orgName' },
  { label: '制单时间', value: 'createDate' }
]

// 团队 欠款合同清单
export const teamDebtContractRecord = [
  { label: '合同编号', value: 'contractCode' },
  { label: '客户名称', value: 'cusName' },
  { label: '当前负责人', value: 'staffCnName' },
  { label: '所属部门', value: 'orgName' }
]

// 团队 维修记录
export const teamMaintainRecord = [
  { label: '客户编号', value: '///' },
  { label: '维修编号', value: '///' },
  { label: '客户名称', value: 'cusName' }
]

// 团队 退货记录
export const teamSalesReturnRecord = [
  { label: '合同编号', value: 'contractNumber' },
  { label: '退货编号', value: 'returnNumber' },
  { label: '客户名称', value: 'cusName' },
  { label: '销售总额', value: 'salePriceTotal' },
  { label: '退款金额', value: 'returnPriceTotal' },
  { label: '罚没费用', value: 'forfeitureProiceTotal' },
  { label: '退货状态', value: 'state' },
  { label: '当前负责人', value: 'staffCnName' },
  { label: '所属部门', value: 'orgName' },
  { label: '申请时间', value: 'createTime' }
]

// 团队 坏账记录
export const teamBadDebtRecord = [
  { label: '坏账编号', value: 'badNumber' },
  { label: '合同编号', value: 'orderContractNumber' },
  { label: '客户名称', value: 'cusName' },
  { label: '坏账金额', value: 'badCount' },
  { label: '审核状态', value: 'state' },
  { label: '当前负责人', value: 'processUser' },
  { label: '所属部门', value: 'orgName' }
]
